// Third-party Library
import { useState } from 'react';
import { Slider } from 'antd';

// Icons
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import StopIcon from '@mui/icons-material/Stop';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

// Service
// import { TIME } from '../../../../../../services/util';

// Styles
import styles from '../../index.module.css'

// const {
//     parseSeconds
// } = TIME

const PlayActionButtons = ({
    videoRef = {},
    times,
    setNext = () => {},
    isLive,
    dataLen,
    thisNext,
    prevNext
}) => {

    const [ playing, isPlaying ] = useState(true)

    /**
     * 
     * Functions
     * 
     */
    const playHDLR = () => {
        videoRef.current.play()
        isPlaying(true)
    }

    const pauseHDLR = () => {
        videoRef.current.pause()
        isPlaying(false)
    }

    const stopHDLR = () => {
        videoRef.current.currentTime = 0
        videoRef.current.pause()
        isPlaying(false)
    }

    const seekHDLR = (e) => {
        if(times.duration !== Infinity) {
            const draggedTime = times.duration * (e / 100)
            videoRef.current.currentTime = draggedTime
        }
    }

    return (
        <div className={styles["container-player-button"]}>
            <div className={styles['container-button']}>
                {/* {
                    !isLive 
                    && */}
                    {
                        prevNext > 0
                        &&
                        <SkipPreviousIcon style={{ color: '#fff' }} onClick={() => setNext(prev => (prev !== 0) && (prev - 1) || 0)}/>
                    }
                {/* } */}
                {
                    playing ?
                    <PauseCircleOutlineIcon style={{ color: '#fff' }} onClick={pauseHDLR} />
                    :
                    <PlayArrowIcon style={{ color: '#fff' }} onClick={playHDLR}/>
                }
                {/* <StopIcon style={{ color: '#fff' }} onClick={() => handleSeek(0)} /> */}
                {/* {
                    !isLive
                    &&
                    <> */}
                        <StopIcon style={{ color: '#fff' }} 
                            onClick={stopHDLR}
                        />
                        {
                            (thisNext < dataLen)
                            &&
                            <SkipNextIcon style={{ color: '#fff' }} onClick={() => setNext(prev => prev + 1)} />
                        }
                    {/* </>
                } */}
            </div>
            {
                !isLive
                &&
                <div style={{ width: '100%' }}>
                    <Slider 
                            trackStyle={{ height: 6 }}
                            railStyle={{ backgroundColor: '#ddd', marginTop: -4 }}
                            handleStyle={{
                                borderColor: 'orange',
                                // backgroundColor: 'white',
                                borderWidth: 2,
                                width: 14,
                                height: 14,
                                marginTop: -4
                            }}
                            value={times.percentage * 100}
                            tooltip = {{
                            formatter: () => times.minsec
                        }}
                            onChange={seekHDLR}
                    />
                </div>
            }
        </div>
    )
}

export default PlayActionButtons